import {
  IsNotEmpty,
  IsArray,
  IsOptional,
  IsDate,
  ValidateNested,
} from "class-validator";
import { QueryDto } from "../query";

import { AdapterSchedulingActionBaseDto } from "./adapter-scheduling-action-base.dto";
import {
  IAdapterSchedulingAction,
  IAdapterSchedulingActionEntity,
} from "./adapter-scheduling-action.interface";
import { Type } from "class-transformer";

export class AdapterSchedulingActionEntityDto
  implements IAdapterSchedulingActionEntity
{
  @IsNotEmpty()
  entity_id: string;

  @IsOptional()
  @IsDate()
  start_date?: Date;
}

export class AdapterSchedulingActionDto
  extends AdapterSchedulingActionBaseDto
  implements IAdapterSchedulingAction
{
  @IsNotEmpty()
  @IsArray()
  @ValidateNested()
  @Type(() => AdapterSchedulingActionEntityDto)
  entities: AdapterSchedulingActionEntityDto[];

  @IsOptional()
  @ValidateNested()
  @Type(() => QueryDto)
  query?: QueryDto;
}
